<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="场次ID" :value="14"></el-option>
                            <el-option label="订单编号" :value="4"></el-option>
							<el-option label="票ID" :value="12"></el-option>                           
                            <el-option label="外部渠道订单编号" :value="8"></el-option>
                            <el-option label="支付平台交易号" :value="9"></el-option>
							<el-option label="结款方名称" :value="15"></el-option>
                            <el-option label="运单号" :value="10"></el-option>
							<el-option label="票品ID" :value="13"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue2" class="input-with-select" size="small">
                        <el-select v-model="params.searchType2" slot="prepend" placeholder="请选择">
                            <el-option label="购买人ID" :value="5"></el-option>
                            <el-option label="联系人手机号码" :value="6"></el-option>
                            <el-option label="观演人姓名" :value="7"></el-option>
                            <el-option label="观演人证件号" :value="11"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.ticketType" placeholder="请选择" size="small">
                        <el-option label="不限制票品性质" value=""></el-option>
                        <el-option label="仅看电子票的" :value="1"></el-option>
                        <el-option label="仅看实体票的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.partner" placeholder="请选择" size="small">
                        <el-option label="不限制业务渠道" value=""></el-option>
                        <el-option v-for="(item,index) in thirdAccount" :key="index" :label="`仅看${item.thirdName}的`" :value="item.source"></el-option>
						<el-option label="仅看秀动的" value="showstart"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.paymentStatus" placeholder="请选择" size="small">
                        <el-option label="不限制支付状态" value=""></el-option>
                        <el-option label="仅看未支付的" :value="1"></el-option>
                        <el-option label="仅看已支付的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.isPrivilegeOrder" placeholder="请选择" size="small">
						<el-option label="不限制下单方式" value=""></el-option>
						<el-option label="仅看普通订单" :value="0"></el-option>
						<el-option label="仅看特权购订单" :value="1"></el-option>
					</el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.orderStatus" placeholder="请选择" size="small">
                        <el-option label="不限制订单状态" value=""></el-option>
                        <el-option label="仅看待支付的" :value="1"></el-option>
                        <el-option label="仅看待发货的" :value="2"></el-option>
                        <el-option label="仅看已发货的" :value="4"></el-option>
                        <el-option label="仅看已完成的" :value="5"></el-option>
                        <el-option label="仅看已过期的" :value="6"></el-option>
                        <el-option label="仅看已取消的" :value="7"></el-option>
                        <el-option label="仅看有效的" :value="8"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="不限制下单终端" value=""></el-option>
                        <el-option v-for="(item,index) in terminalList" :key="index" :label="`仅看${item.name}的`" :value="item.code"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <!-- <el-select v-model="params.payPlatform" placeholder="请选择" size="small">
                        <el-option label="不限制支付渠道" value=""></el-option>
                        <el-option label="仅看支付宝的" :value="1"></el-option>
                        <el-option label="仅看微信的" :value="2"></el-option>
                        <el-option label="仅看Paypal的" :value="3"></el-option>
                        <el-option label="仅看财付通的" :value="4"></el-option>
                        <el-option label="仅看微信-抖音小程序的" :value="5"></el-option>
                        <el-option label="仅看支付宝-抖音小程序的" :value="6"></el-option>
						<el-option label="仅看云闪付的" :value="7"></el-option>
						<el-option label="仅看云闪付-支付宝的" :value="10"></el-option>
						<el-option label="仅看云闪付-微信的" :value="11"></el-option>
						<el-option label="仅看微信-小红书小程序的" :value="8"></el-option>
						<el-option label="仅看支付宝-小红书小程序的" :value="9"></el-option>
                    </el-select> -->
					
					<el-select v-model="params.payPlatform" placeholder="不限制支付渠道" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制支付渠道" value=""></el-option>
					    <el-option v-for="(item, index) in Paymentgateway" :label="item.value" :key="index" :value="item.key"></el-option>
					</el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.skuType" placeholder="请选择" size="small">
                        <el-option label="不限制取票方式" value=""></el-option>
                        <el-option label="仅看网络发送的" :value="1"></el-option>
                        <el-option label="仅看寄送的" :value="2"></el-option>
                        <el-option label="仅看自取的" :value="3"></el-option>
                    </el-select>
                </el-col>       
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.afterSalesStatus" placeholder="请选择" size="small">
                        <el-option label="不限制售后状态" :value="0"></el-option>
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看待退货的" :value="2"></el-option>
                        <el-option label="仅看待退款的" :value="3"></el-option>
                        <el-option label="仅看已退款的" :value="4"></el-option>
                        <el-option label="仅看已拒绝的" :value="5"></el-option>
                        <el-option label="仅看已过期的" :value="6"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isTransfer" placeholder="请选择" size="small">
				        <el-option label="不限制是否转赠" value=""></el-option>
				        <el-option label="仅看有过转赠的" :value="1"></el-option>
				        <el-option label="仅看没有转赠的" :value="0"></el-option>				        
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isAlternateOrder" placeholder="请选择" size="small">
				        <el-option label="不限制是否候补订单" value=""></el-option>
				        <el-option label="仅看非候补订单" :value="0"></el-option>
				        <el-option label="仅看候补订单" :value="1"></el-option>				        
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.alternateStatus" placeholder="请选择" size="small">
				        <el-option label="不限制候补状态" value=""></el-option>
				        <el-option label="仅看待候补的" :value="1"></el-option>
				        <el-option label="仅看候补中的" :value="2"></el-option>
						<el-option label="仅看候补完成的" :value="3"></el-option>
						<el-option label="仅看候补失败的" :value="4"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.preAuthStatus" placeholder="请选择" size="small">
				        <el-option label="不限制授权状态" value=""></el-option>
				        <el-option label="仅看待授权的" :value="1"></el-option>
				        <el-option label="仅看已授权的" :value="2"></el-option>
						<el-option label="仅看取消授权的" :value="3"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.consignStatus" placeholder="请选择" size="small">
				        <el-option label="不限制托售状态" value=""></el-option>
				        <el-option label="仅看未托售的" :value="-1"></el-option>
				        <el-option label="仅看托售中的" :value="2"></el-option>
						<el-option label="仅看托售成功的" :value="3"></el-option>
						<el-option label="仅看托售取消的" :value="1"></el-option>
						<el-option label="仅看托售失败的" :value="4"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.preBuyStatus" placeholder="请选择" size="small">
				        <el-option label="不限制定时购票状态" value=""></el-option>
				        <el-option label="仅看定时购票的" :value="1"></el-option>
				        <el-option label="仅看定时购票中的" :value="2"></el-option>
						<el-option label="仅看定时购票成功的" :value="3"></el-option>
						<el-option label="仅看定时购票失败的" :value="4"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.addrName" class="input-with-select" size="small">
                        <el-select v-model="params.addrType" slot="prepend" placeholder="请选择" style="width:170px !important">
                            <el-option label="下单时IP所在城市" :value="1"></el-option>
                            <el-option label="下单时IP所在省份" :value="2"></el-option>
                            <el-option label="下单时GPS所在城市" :value="3"></el-option>
                            <el-option label="下单时GPS所在省份" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制演出来源" value=""></el-option>
				        <el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index" :value="item.key"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="下单时间" :value="1"></el-option>
                                <el-option label="退款时间" :value="2"></el-option>
                                <el-option label="支付时间" :value="3"></el-option>
                                <el-option label="取消时间" :value="4"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            :clearable="false"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activiOrder/createExport')" type="primary" icon="el-icon-download" size="small" @click="download('/activiOrder/createExport')" :loading="downLoading">导出订单</el-button>
			<el-button v-if="$utils.have('/activiOrder/exportCommonPerformer')" type="primary" icon="el-icon-download" size="small" @click="download('/activiOrder/exportCommonPerformer')"  :loading="downLoading2" >导出观演人</el-button>			
            <el-button v-if="$utils.have('/activiOrder/batchImport')"  type="primary" icon="el-icon-position" size="small" @click="$refs.batchDeliver.show()">批量发货</el-button>
            <el-button v-if="$utils.have('/activiOrder/createExportForShunFeng') && ticketTypeFlag != 1"  type="primary" icon="el-icon-download" size="small"  @click="download('/activiOrder/createExportForShunFeng')"  :loading="downLoading3">按顺丰格式导出实体票寄送订单</el-button>
			<el-button v-if="$utils.have('/activiOrder/createExport')" type="primary"  size="small"  @click="batchCancel(1,'')" :loading="batchLoading2">批量取消订单</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column type="expand" label="展开">
                    <template slot-scope="props">
                        <template v-if="props.row.afterSales && props.row.afterSales.length > 0">
                            <div v-for="(item,index) in props.row.afterSales" :key="index" class="PD10">
								<span><span class="color-info">来源：</span>{{source.get(item.source)}}</span>
                                <span class="ML20"><span class="color-info">售后状态：</span>{{afterSalesStatus.get(item.afterSalesStatus)}}</span>
								<span class="ML20"><span class="color-info">申请退票数量：</span>{{item.refundNum}}</span>
								<span class="ML20"><span class="color-info">申请退款金额：</span>{{item.refundAmount}}</span>
								<span class="ML20"><span class="color-info">申请时退票手续费（比例）：</span> {{item.refundFeeStr}} <span v-if="item.refundFeeRatioStr">（{{item.refundFeeRatioStr}}）</span></span>
								<span class="ML20" v-if="item.afterSalesStatus == 3 || item.afterSalesStatus == 4"><span class="color-info">审核后确认退款金额：</span>{{item.recordRefundAmount}}</span>
								<span class="ML20" v-if="item.afterSalesStatus == 3 || item.afterSalesStatus == 4"><span class="color-info">审核后确认退票手续费（比例）：</span>{{item.recordRefundFeeStr}} <span v-if="item.recordRefundFeeRatioStr">（{{item.recordRefundFeeRatioStr}}）</span></span>
                                <span v-if="item.refundTime" class="ML20"><span class="color-info">实际退款时间：</span>{{item.refundTime}}</span>
                            </div>
                        </template>
                        <div v-else>暂无售后信息</div>
                    </template>
                </el-table-column>
                <el-table-column prop="ticketTypeNames" label="票品性质"></el-table-column>
                <el-table-column prop="thirdAccountName" label="销售渠道" min-width="100"></el-table-column>
				<el-table-column label="授权和候补状态" min-width="150">
					<template slot-scope="scope">
						<p>授权状态：
							<span v-if="scope.row.preAuthStatus == 1" class="color-warning">待授权</span>
							<span v-else-if="scope.row.preAuthStatus == 2" class="color-success">已授权</span>
							<span v-else-if="scope.row.preAuthStatus == 3" class="color-info">取消授权</span>
							<span v-else>无</span>
						</p>
						<p>
							候补状态：
							<span v-if="scope.row.alternateStatus == 1" class="color-warning">待候补</span>
							<span v-else-if="scope.row.alternateStatus == 2" class="color-black">候补中</span>
							<!-- 候补完成：hover 显示候补成功时间 -->
							<el-tooltip v-else-if="scope.row.alternateStatus == 3 && scope.row.alternateTime" effect="dark" :content="`候补成功时间: ${scope.row.alternateTime}`" placement="top">
								<span class="color-success hand">候补完成</span>
							</el-tooltip>
							<span v-else-if="scope.row.alternateStatus == 3" class="color-success">候补完成</span>
							<span v-else-if="scope.row.alternateStatus == 4" class="color-danger">候补失败</span>
							<span v-else>无</span>
						</p>
				    </template>
				</el-table-column>
				<el-table-column prop="consignStatusView" label="托售状态"></el-table-column>
				<!-- 定时购票状态：成功的 hover 显示定时购成功时间（出票时间） -->
				<el-table-column label="定时购票状态" min-width="130">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.preBuyStatus == 3 && scope.row.preBuySuccessTime" effect="dark" :content="`定时购成功时间: ${scope.row.preBuySuccessTime}`" placement="top">
							<span class="hand">{{scope.row.preBuyStatusView}}</span>
						</el-tooltip>
						<span v-else>{{scope.row.preBuyStatusView}}</span>
					</template>
				</el-table-column>
                <el-table-column prop="paymentStatus" label="支付和订单状态" min-width="130">					
                    <template slot-scope="scope">
						<p>支付状态：
							<span v-if="scope.row.paymentStatus == 1">未支付</span>
							<span v-else-if="scope.row.paymentStatus == 2" class="color-success" >已支付</span>
						</p>
						<p>订单状态：
							 {{orderStatus.get(scope.row.orderStatus)}}
						</p>
                    </template>
                </el-table-column>				
                <!-- <el-table-column prop="orderStatus" label="订单状态">
                    <template slot-scope="scope">
                       {{orderStatus.get(scope.row.orderStatus)}}
                    </template>
                </el-table-column> -->
                <!--<el-table-column prop="id" label="订单ID"></el-table-column>-->
                <el-table-column prop="sn" label="订单编号" min-width="140"></el-table-column>
				<el-table-column prop="goodId" label="演出ID"></el-table-column>
				<el-table-column prop="goodName" label="演出名称" show-overflow-tooltip min-width="250">
				    <template slot-scope="scope">
				        <el-link class="ellipsis" :href="`${sswap}/pages/activity/detail/detail?activityId=${scope.row.goodId}`" target="_blank">{{scope.row.goodName}}</el-link>
				    </template>
				</el-table-column>
                <el-table-column prop="thirdOrderId" label="外部渠道订单编号" min-width="120"></el-table-column>
                <el-table-column prop="outTradeNo" label="支付平台交易号" min-width="240"></el-table-column>
                <el-table-column prop="ticketName" label="票品名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payNum" label="购票总数"></el-table-column>
                <el-table-column label="总价" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.totalAmountStr}}</p>
						<p>乐迷服务费：<template v-if="scope.row.paymentStatus == 2">{{scope.row.userServiceFee}}</template></p>
					</template>
				</el-table-column>
                <el-table-column  label="优惠" min-width="140">
					<template slot-scope="scope">
						<p>优惠券：{{scope.row.couponDiscountView}}</p>
						<p>立减金额：{{scope.row.randomDiscountView}}</p>
						<p>其它优惠：{{scope.row.otherDiscountView}}</p>
					</template>
				</el-table-column>
                <el-table-column label="实际支付" min-width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.realPayAmountStr}}</p>
						<p>乐迷服务费：<template v-if="scope.row.paymentStatus == 2">{{scope.row.userServiceFee}}</template></p>
					</template>
				</el-table-column>
                <el-table-column prop="createUser" label="购买人ID"></el-table-column>
                <el-table-column prop="telephone" label="联系手机" min-width="130">
                    <template slot-scope="scope">
                        {{scope.row.areaCode && scope.row.telephone ? '+'+scope.row.areaCode.split('_')[0] : ''}} {{scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column prop="terminal" label="下单终端" min-width="90"></el-table-column>
                <el-table-column prop="payPlatformName" label="支付渠道" min-width="130"></el-table-column>                
                <el-table-column prop="performeres" label="观演人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="下单时间" min-width="150"></el-table-column>
                <el-table-column prop="payTime" label="支付时间" min-width="150"></el-table-column>
                <el-table-column prop="cancelTime" label="取消时间" min-width="150"></el-table-column>
                <!-- <el-table-column prop="refundTime" label="退款时间" min-width="150"></el-table-column> -->
                <el-table-column prop="deliveryTypes" label="取票方式"></el-table-column>
                <el-table-column prop="customerName" label="收货人" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="provinceName" label="收货省份"></el-table-column>
                <el-table-column prop="cityName" label="收货城市"></el-table-column>
                <el-table-column prop="address" label="收货地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="expressName" label="快递公司" show-overflow-tooltip></el-table-column>
                <el-table-column prop="expressNo" label="运单号" show-overflow-tooltip></el-table-column>
				<el-table-column prop="activityChannelView" label="演出来源" show-overflow-tooltip></el-table-column>
                <el-table-column prop="changeTieView" label="换绑设置"  min-width="150"></el-table-column>
                <el-table-column prop="transferView" label="转赠" min-width="150"></el-table-column>
                <el-table-column prop="ip" label="下单时IP地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ipCity" label="下单时IP所在城市" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ipProvince" label="下单时IP所在省份" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gpsCity" label="下单时GPS所在城市" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gpsProvince" label="下单时GPS所在省份" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activiOrder/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="edit(scope.row.id)"
                            >管理</el-button>
                        <el-button
                            v-if="scope.row.ticketType == 2 && !scope.row.expressName && !scope.row.expressNo && scope.row.orderStatus != 6 && $utils.have('/activiOrder/deliverGoods')"
                            type="text"
                            size="small"
                            icon="el-icon-position"
                            @click="$refs.updateDeliverInfo.show(scope.row)"
                            >发货</el-button>
                        <el-button
                            v-if="$utils.have('/activiOrder/cancel') && scope.row.canCancelOrder == true ||  (scope.row.preAuthStatus == 2 && scope.row.alternateStatus == 2 ) || ( scope.row.preAuthStatus == 2 && scope.row.preBuyStatus == 2 )"
                            type="text"
                            size="small"
                            icon="el-icon-remove-outline"
							@click="batchCancel(2,scope.row)"
                            >取消</el-button>
						
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <UpdateDeliverInfo ref="updateDeliverInfo" @onUpdate="getDataList"></UpdateDeliverInfo>
        <BatchDeliver ref="batchDeliver" @onUpdate="getDataList"></BatchDeliver>
		
		<el-dialog :title="showType == 1 ?'批量取消订单': '取消订单'" :visible.sync="dialogVisible" width="600px" center v-if="batchData">			
			<div class="dialog-content">
				<div>
				   <p class="color-danger">取消之前请确认核对：</p>
				   <p class="MT10">演出ID：{{batchData.activityId}} <span v-if="batchData && batchData.orderStatus == 4 " class="color-danger">（实体票，已发货）</span></p>
				   <p class="MT10">演出名称：{{batchData.activityName}} </p>
				   <p class="MT10 color-danger">需取消订单数:{{batchData.cancelNum}},包含以下票品</p>
				   <div class="temp-table"  v-if="batchData && batchData.ticketList && batchData.ticketList.length > 0">
				       <el-table
				           :data="batchData.ticketList"
				           style="width: 100%"
				           size="small"
				           border
				       >
				           <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
						   <el-table-column prop="userName" label="观演人" v-if="showType != 1"></el-table-column>
						   <el-table-column prop="orderTime" label="下单时间" v-if="showType != 1"></el-table-column>	
				           <el-table-column prop="num" label="数量" min-width="30"></el-table-column>				           
				       </el-table>
				   </div>
				   <template v-if="batchData && batchData.cancelRecord && batchData.cancelRecord.length > 0">
					   <p class="MT10">当前演出用户取消记录:</p>
					   <div class="temp-table">
					       <el-table
					           :data="batchData.cancelRecord"
					           style="width: 100%"
					           size="small"
					           border
					       >
					           <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
					           <el-table-column prop="userName" label="观演人"></el-table-column>
					           <el-table-column prop="orderTime" label="下单时间"></el-table-column>
					           <el-table-column prop="num" label="已取消订单数" min-width="30"></el-table-column>
					       </el-table>
					       <el-link class="link color-blue"  :href="`/activityManage/order/list?searchType=1&searchValue=${batchData.activityId}&searchType2=5&searchValue2=${batchData.userId}&orderStatus=7`" target="_blank">点击查看已取消订单</el-link>
					   </div>
				   </template>
				   <!-- 关联的权益票订单（取消主票会同步取消权益票订单） -->
				   <template v-if="batchData && batchData.benefitOrderList && batchData.benefitOrderList.length > 0">
					   <p class="MT10 color-danger">该订单有关联的权益票订单,取消后将会同步取消以下权益票订单:</p>
					   <div class="temp-table">
					       <el-table
					           :data="batchData.benefitOrderList"
					           style="width: 100%"
					           size="small"
					           border
					       >
					           <el-table-column prop="orderSn" label="权益票订单编号" min-width="150"></el-table-column>
					           <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column>
					           <el-table-column label="实付金额" min-width="90">
					               <template slot-scope="scope">{{ (scope.row.paidAmount / 10000).toFixed(2) }}元</template>
					           </el-table-column>
					           <el-table-column label="订单状态" min-width="80">
					               <template slot-scope="scope">{{ benefitOrderStatusText(scope.row.orderStatus) }}</template>
					           </el-table-column>
					       </el-table>
					   </div>
				   </template>				   
				   <div class="MT20">
					   <small class="color-danger">*</small>取消原由：
					   <el-input type="textarea" v-model="reason" placeholder="请填写取消原由" maxlength="100" class="MT10"></el-input>
				   </div>
				   <div class="MT20">
					   <small class="color-danger">*</small>请选择是否需要扣除手续费：
				   		<el-select v-model="isCalculateRefundFee" placeholder="请选择是否需要扣除手续费" size="small" style="width: 100%;" class="MT10">				   		   
				   		    <el-option label="不扣除手续费" value="0"></el-option>
				   		    <el-option label="需要扣除手续费" value="1"></el-option>
							<el-option label="手动设置扣款百分比" value="2" v-if="showType != 1"></el-option>
				   		</el-select>
						<div v-if="batchData.refundRule == 1" class="MT10 color-danger">注意：当前演出设置了退款手续费规则，请酌情选择是否扣除手续费!</div>
						<div v-if="batchData.orderStatus == 4" class="MT10 color-danger">注意：当前有订单属于实体票订单且已经发货，请酌情选择是否取消!</div>
				   </div>
				    <div class="MT20" v-if="isCalculateRefundFee == 2 && showType != 1">
						<small class="color-danger">*</small>扣款百分比：
						<el-input-number v-model="refundFeeRatio" :min="0" :max="100" :precision="2" controls-position="right" size="mini" style="width: 200px;"></el-input-number> %
						<span class="ML20" v-if="refundFeeRatio">{{ ((batchData.orderAmount * refundFeeRatio) / 1000000).toFixed(2) }} 元</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closePop()">取 消</el-button>
				<el-button type="primary" @click="batchCancelSubmit">确 定</el-button>
			</span>
		</el-dialog>
    </div>
</template>

<script>
import UpdateDeliverInfo from './components/updateDeliverInfo';
import BatchDeliver from './components/batchDeliver';
import {fetchTerminal,fetchThirdAccount,fetchPayList} from '@/assets/js/commonApi';
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    dateType: 1,
    startTime:'',
    endTime:'',
    ticketType: '',
    partner: '',
    paymentStatus: '',
    orderStatus:'',
    terminal: '',
    payPlatform: '',
    skuType: '',
    afterSalesStatus: 0,
	isTransfer:'',
    searchType2: 5,
    searchValue2: "",
    addrType: 1,
    addrName: "",
	isAlternateOrder:'',
	isPrivilegeOrder:'',
	alternateStatus:'',
	batchCancelId:'',
	preAuthStatus:'',
	consignStatus:'',
	preBuyStatus:'',
	activityChannel:"",
	
}

export default {
    components:{UpdateDeliverInfo,BatchDeliver},
    data(){
        return{
            data: null,
            dataList: null,
            defaultEndTime: this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' ) + ' 23:59:59',
            defaultStartTime: this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 360), 'yyyy-MM-dd' ) + ' 00:00:00',
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                dateType: parseInt(this.$route.query.dateType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                ticketType: this.$route.query.ticketType ? parseInt(this.$route.query.ticketType) : '',
                partner: this.$route.query.partner || '',
                paymentStatus: this.$route.query.paymentStatus ? parseInt(this.$route.query.paymentStatus) : '',
                orderStatus: this.$route.query.orderStatus ? parseInt(this.$route.query.orderStatus) : '',				
				terminal:this.$route.query.terminal || '',
                payPlatform: this.$route.query.payPlatform || '',
                skuType: this.$route.query.skuType ? parseInt(this.$route.query.skuType) : '',
                afterSalesStatus: parseInt(this.$route.query.afterSalesStatus || 0),
                searchType2: parseInt(this.$route.query.searchType2 || 5),
                searchValue2: this.$route.query.searchValue2 || '',
                addrType: parseInt(this.$route.query.addrType || 1),
				batchCancelId:this.$route.query.batchCancelId || '',
                addrName: this.$route.query.addrName || '',
				isAlternateOrder: this.$route.query.isAlternateOrder ? parseInt(this.$route.query.isAlternateOrder) : '',
				isPrivilegeOrder: this.$route.query.isPrivilegeOrder ? parseInt(this.$route.query.isPrivilegeOrder) : '',
				alternateStatus: this.$route.query.alternateStatus ? parseInt(this.$route.query.alternateStatus) : '',
				preAuthStatus: this.$route.query.preAuthStatus ? parseInt(this.$route.query.preAuthStatus) : '',
				consignStatus: this.$route.query.consignStatus ? parseInt(this.$route.query.consignStatus) : '',
				preBuyStatus: this.$route.query.preBuyStatus ? parseInt(this.$route.query.preBuyStatus) : '',
				
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            thirdAccount:[],
            terminalList:[],
            downLoading: false,
			downLoading2:false,
			downLoading3:false,
            ticketTypeFlag: 1,
            datetimerange: [this.$route.query.startTime || '' , this.$route.query.endTime || ''],
			batchLoading:false,
			batchLoading2:false,
			batchLoading3:false,
			dialogVisible:false,
			dialogVisible2:false,
			batchData:null,
			singleData:null,
			reason:'主办同意单独退款',
			isCalculateRefundFee:'',
			showType:'',
			activityChannel:[],
			refundFeeRatio:undefined,
			Paymentgateway:[]
			
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消'],
				[8,'预购失败'],
            ])
        },
        afterSalesStatus(){
            return new Map([
                [1,'待审核'],
                [2,'待退货'],
                [3,'待退款'],
                [4,'已退款'],
                [5,'已拒绝'],
                [6,'已过期'],
            ])
        },
		source(){
		    return new Map([
				[-1,'后台取消'],
				[0,'演出变动'],
		        [1,'用户申请'],
		        [2,'托售成功'],
		        [3,'候补失败'],
		        [4,'定时购失败'],
		        [5,'过期支付'],
		        [6,'支付取消'],
				[7,'库存异常'],
		    ])
		}
    },
    mounted() {
		this.getChannel();
        this.datetimerange = [this.$route.query.startTime || this.defaultStartTime , this.$route.query.endTime || this.defaultEndTime]
        this.getDataList();
        this.getThirdAccount();
		this.fetchPayList();
        this.getTerminal();
		
    },
    methods:{
        //获取第三方平台
        getThirdAccount(){
            fetchThirdAccount({isThird:1})
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.thirdAccount = result.thirdAccounts || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
		async fetchPayList() {
		    const res = await fetchPayList({
		        
		    }).catch(() => {
		        return {data: {state: '0', msg: '请求错误'}};
		    });
		
		    const { state, msg, result} = res.data;
		
		    if(state !== '1') {
		        return this.$message.error(msg || '请求失败');
		    }
		
		    this.Paymentgateway = result || []
		    console.log(this.Paymentgateway)
		},
		//获取演出渠道
		getChannel() {
			this.$request({
				url: "/common/activitySource",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.activityChannel = result || []
				}
			})
		},
        //获取终端
        getTerminal(){
             fetchTerminal()
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.terminalList =  result || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
        //获取列表
        getDataList() {
            if( (!this.datetimerange || this.datetimerange.length < 1) && !this.params.searchValue ){
                this.$message.error('请选择查询时间段')
                return;
            }
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/activiOrder/list",
                method: "POST",
                data: this.params ,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        this.ticketTypeFlag = this.dataList && this.dataList.find(v => v.ticketType == 1) ? 1 : null;

                    } else {
                        this.data = null;
                        this.dataList = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		
		//权益票订单状态文案
		benefitOrderStatusText(status){
			const _map = { 1: '待处理', 2: '待发货', 3: '部分发货', 4: '已发货', 5: '已完成', 6: '已过期', 7: '已取消' };
			return _map[status] || '-';
		},
		batchCancel(type,data){
			if( (data.preAuthStatus == 2 && data.alternateStatus == 2 ) || ( data.preAuthStatus == 2 && data.preBuyStatus == 2 ) ){				
				this.singleFun2(data)
			}else{
				this.showType = type // 只用来判断弹框里面标题文字是批量取消还是单个取消
				if( (!this.datetimerange || this.datetimerange.length < 1) && !this.params.searchValue ){
					this.$message.error('请选择查询时间段')
					return;
				}			
				var params = {};
				if( type ==  2 ){
					params = {
					    ...this.params,
					    startTime:this.datetimerange && this.datetimerange[0] || '',
					    endTime:this.datetimerange && this.datetimerange[1] || '',
						searchType:3,
						searchValue:data.id
					}	
				}else{
					params = {
					    ...this.params,
					    startTime:this.datetimerange && this.datetimerange[0] || '',
					    endTime:this.datetimerange && this.datetimerange[1] || ''
					}
				} 
				
				this.$request({
					url: "/activiOrder/batchCancelCheck",
					method: "POST",
					data: params ,
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1) {
							//this.$message.error(result.errorInfo);
							
							if( result.errorInfo){
								this.$alert(result.errorInfo, '取消订单', {confirmButtonText: '知道了'});
							}
							if( result.ticketList && result.ticketList.length > 0 ){
								this.batchData = result
								this.dialogVisible = true
							}
							if( result.ticketList && result.ticketList.length == 0 && result.cancelNum == 0 ){
								this.$message.warning("暂无可处理的订单");
							}
						} else {
							
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})	
			}
					
		},		
		batchCancelSubmit(){
			if( this.reason == '' ){
				return this.$message.error("取消原由不能为空");
			}
			if( this.isCalculateRefundFee == ''){
				return this.$message.error("请选择是否需要扣除手续费");
			}
			//关联权益票订单确认（取消主票会同步取消关联的权益票订单）
			if( this.batchData.benefitOrderList && this.batchData.benefitOrderList.length > 0 ){
				const _sns = this.batchData.benefitOrderList.map(v => v.orderSn).join('、');
				this.$confirm(`该订单有关联的权益票订单:<span class="color-danger">${_sns}</span>,将会同步取消对应权益票订单,确认取消?`, '取消订单', {
					type: 'warning',
					confirmButtonText: '确认取消',
					cancelButtonText: '再想想',
					showClose: false,
					customClass: 'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.batchCancelSubmitRun();
				}).catch(() => {})
				return;
			}
			this.batchCancelSubmitRun();
		},
		batchCancelSubmitRun(){
			if( this.isCalculateRefundFee == 0 && this.batchData.refundRule == 1 ){
				this.$confirm(`注意:当前演出设置了<a href="/activityManage/activity/edit/finance/${this.batchData.activityId}" class="color-blue" target="_blank">退款手续费规则</a><br>是否确认<span class="color-danger">不扣除手续费？</span>`, '取消订单', {
					type: 'wraning',
					confirmButtonText: '不扣除手续费',
					cancelButtonText:'返回修改',
					showClose:false,
					customClass:'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,					
				}).then(() => {
					if( this.showType == 1 ){ //批量取消
						//判断是不是实体票已发货的
						if( this.batchData.orderStatus == 4 ){
							this.$confirm(`注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
								type: 'wraning',
								confirmButtonText: '继续取消',
								cancelButtonText:'返回',
								showClose:false,
								customClass:'mpop',
								closeOnClickModal: false,
								dangerouslyUseHTMLString: true,					
							}).then(() => {
								this.batchFun()
							}).catch(() => {}) 
						}else{
							this.batchFun()
						}
					}else{
						//判断是不是实体票已发货的
						if( this.batchData.orderStatus == 4 ){
							this.$confirm(`注意:当前订单是<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
								type: 'wraning',
								confirmButtonText: '继续取消',
								cancelButtonText:'返回',
								showClose:false,
								customClass:'mpop',
								closeOnClickModal: false,
								dangerouslyUseHTMLString: true,					
							}).then(() => {
								this.singleFun()
							}).catch(() => {}) 
						}else{
							this.singleFun()
						}
					}
				}).catch(() => {})
				
			}else{				
				if( this.showType == 1 ){ //批量取消
					//判断是不是实体票已发货的
					if( this.batchData.orderStatus == 4 ){
						this.$confirm(`注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
							type: 'wraning',
							confirmButtonText: '继续取消',
							cancelButtonText:'返回',
							showClose:false,
							customClass:'mpop',
							closeOnClickModal: false,
							dangerouslyUseHTMLString: true,					
						}).then(() => {
							this.batchFun()
						}).catch(() => {}) 
					}else{
						this.batchFun()
					}
				}else{
					//判断是不是实体票已发货的
					if( this.batchData.orderStatus == 4 ){
						this.$confirm(`注意:当前订单是<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
							type: 'wraning',
							confirmButtonText: '继续取消',
							cancelButtonText:'返回',
							showClose:false,
							customClass:'mpop',
							closeOnClickModal: false,
							dangerouslyUseHTMLString: true,					
						}).then(() => {
							this.singleFun()
						}).catch(() => {}) 
					}else{
						this.singleFun()
					}
				}
						
			}		
		},
		//批量处理
		batchFun(){
			this.batchLoading2 = true
			this.$request({
				url: "/activiOrder/batchCancel",
				method: "POST",
				data:{
					...this.batchData,
					reason:this.reason,
					isCalculateRefundFee:this.isCalculateRefundFee
				} 
			})
			.then((res) => {
				const { state, msg, result } = res.data;
				if (state == 1) {
					this.$confirm('批量取消订单需要审核通过后才能生效，请提醒对应的审核人进行处理！', '取消订单', {
						confirmButtonText: '知道了',	
						showCancelButton:false,
						type: 'success',
						showClose: false,
						closeOnClickModal: false
					}).then(() => {
						this.$message.success("操作成功");
						this.getDataList();
						this.dialogVisible = false
						this.isCalculateRefundFee = ''
						this.reason = '主办同意单独退款'
						
					}).catch(() => {})
					
				} else {			            
					this.$message.error(msg || "请求失败");						
					
					this.isCalculateRefundFee = ''
					this.reason = '主办同意单独退款'
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.batchLoading2 = false; // 请求结束复位按钮加载状态
			});
		},
		//单个处理
		singleFun(){
			if (this.isCalculateRefundFee == 2) {				
				if (this.refundFeeRatio == undefined ) {
					return this.$message.warning('请填写扣款百分比');					
				}
				if (this.refundFeeRatio == 0) {
					return this.$message.warning('扣款百分比必须大于0');					
				}			        
			}
			this.listLoading = true;
			this.$request({
				url: '/activiOrder/cancel',
				method: 'POST',
				params: {
					orderId:this.batchData.orderIds[0],
					isCalculateRefundFee:this.isCalculateRefundFee,
					reason:this.reason,
					refundFeeRatio:this.refundFeeRatio
				}
			}).then(res => {
				const { state, msg } = res.data;
				if( state == 1 ){
					this.$message.success("操作成功");
					this.getDataList();
					this.dialogVisible = false
					this.isCalculateRefundFee = ''
					this.reason = '主办同意单独退款'
					this.refundFeeRatio = undefined
				}else{
					this.$message.error(msg || "请求失败");
					this.refundFeeRatio = undefined
					this.isCalculateRefundFee = ''
					this.reason = '主办同意单独退款'
				}
			})
		},
		//单个处理 取消授权订单(候补中、定时购中)  data.alternateStatus == 2 ) || ( data.preAuthStatus == 2 && data.preBuyStatus == 2 ) ){	
		singleFun2(data){			
			let text = '';
			if (data.alternateStatus === 2) {
			  text = '候补中';
			} else if (data.preBuyStatus === 2) {
			  text = '定时购中';
			}
			this.$confirm(`注意:取消该预授权订单，<span class="color-danger"> ${text} </span>将自动失败，并释放预授权.是否确认<span class="color-danger">继续取消?</span>`, '取消订单', {
				type: 'wraning',
				confirmButtonText: '继续取消',
				cancelButtonText:'取消',
				showClose:false,
				customClass:'mpop',
				closeOnClickModal: false,
				dangerouslyUseHTMLString: true,	
			}).then(() => {
				this.$request({
					url: '/activiOrder/cancelAuth',
					method: 'POST',
					params: {
						orderId:data.id
					}
				}).then(res => {
					const { state, msg } = res.data;
					if( state == 1 ){
						this.$message.success("操作成功");
						this.getDataList();
						this.dialogVisible = false
						
					}else{
						this.$message.error(msg || "请求失败");
						
					}
				})
				
			}).catch(() => {
				
			})			
			
		},
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.datetimerange = [this.defaultStartTime , this.defaultEndTime];
            this.getDataList();
        },
		 
		//导出订单
        download(action){            
			if( action == '/activiOrder/createExport'){
				this.downLoading = true;
			}
			if( action == '/activiOrder/exportCommonPerformer'){
				this.downLoading2 = true
			}
			if( action == '/activiOrder/createExportForShunFeng'){
				this.downLoading3 = true
			}
            this.$request({
                url:action,// "/activiOrder/createExport",
                method: "POST",
                data: this.params ,
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    if( action == '/activiOrder/createExport'){
                    	this.downLoading = false;
                    }
                    if( action == '/activiOrder/exportCommonPerformer'){
                    	this.downLoading2 = false
                    }
                    if( action == '/activiOrder/createExportForShunFeng'){
                    	this.downLoading3 = false
                    }
                });
        },
		closePop(){
			this.dialogVisible = false			
			this.isCalculateRefundFee = ''
			this.reason = '主办同意单独退款'
			this.listLoading = false;
			this.refundFeeRatio = undefined
		},
		
        //编辑事件
        edit(id){
            this.$router.push({
                path: `/activityManage/order/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params 
                    ),
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__row expanded{
    div{
        line-height: 30px;
    }
}
::v-deep .color-blue{	
	color:#409EFF;
	font-size: 12px
}
.temp-table{
	margin-top: 10px;
	max-height: 300px;
	min-height: 100px;
	overflow-y:auto;
	::v-deep .el-table,.el-table thead{
		color:#f00
	}	
	
}
.color-black{
	color: #000;
	font-weight: bold;
}
</style>